
    <div fxLayout="column">
      <h3 class="mat-title" fxLayout="row" fxLayoutAlign="space-between center">
        <span *ngIf="title; else genericTitle">{{ title }}</span>
        <ng-template #genericTitle>{{
          'add comment' | translate | sentancecase
        }}</ng-template>
        <button mat-icon-button (click)="onClose()">
          <mat-icon svgIcon="close">clear</mat-icon>
        </button>
      </h3>
      <ml-comment-form #formComponent (post)="onAdd($event)"></ml-comment-form>
      <ml-comments-list
        [comments]="comments$ | async"
        [loadingMore]="loadingMore$ | async"
        [loading]="loading$ | async"
        [next]="next$ | async"
        [currentUser]="currentUser$ | async"
        (loadMore)="onLoadMore()"
        (deleteComment)="onDelete($event)"
      ></ml-comments-list>
    </div>
  